import {MenuModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import DefaultSubheader from "./DefaultSubheader"
import ProductsSubheader from "./ProductsSubheader"
import ProductsSubheaderInside from "./ProductsSubheaderInside"
import styles from "./Subheader.module.scss"

type Props = {
	data: MenuModuleType
	isScrolled: boolean
	hovered: boolean
}

const Subheader = (props: Props) => {
	const item = props.data
	const chidlren = item.children
	const isScrolled = props.isScrolled
	const hovered = props.hovered

	if (!chidlren) {
		return null
	}

	return (
		<div
			className={`${styles.subheaderContainer} ${
				isScrolled ? styles.scrolled : ""
			} ${hovered ? styles.hovered : ""} ${
				item.slug === "products" ? styles.product : ""
			}`}
		>
			{!hovered && item.slug === "products" && (
				<ProductsSubheaderInside data={chidlren} />
			)}
			{!hovered && item.slug === "pricing" && (
				<ProductsSubheader data={chidlren} />
			)}
			{hovered &&
				(item.slug === "products" || item.slug === "pricing") && (
					<ProductsSubheader data={chidlren} />
				)}
			{item.slug !== "products" && item.slug !== "pricing" && (
				<DefaultSubheader title={item.menuTitle} data={chidlren} />
			)}
		</div>
	)
}

export default Subheader
